var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSingleview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_281_2",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H7C7.55228 0 8 0.447715 8 1V9C8 9.55228 7.55228 10 7 10H1C0.447715 10 0 9.55228 0 9V1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5H7V-1.5H1V1.5ZM6.5 1V9H9.5V1H6.5ZM7 8.5H1V11.5H7V8.5ZM1.5 9V1H-1.5V9H1.5ZM1 8.5C1.27614 8.5 1.5 8.72386 1.5 9H-1.5C-1.5 10.3807 -0.380712 11.5 1 11.5V8.5ZM6.5 9C6.5 8.72386 6.72386 8.5 7 8.5V11.5C8.38071 11.5 9.5 10.3807 9.5 9H6.5ZM7 1.5C6.72386 1.5 6.5 1.27614 6.5 1H9.5C9.5 -0.380712 8.38071 -1.5 7 -1.5V1.5ZM1 -1.5C-0.380712 -1.5 -1.5 -0.380711 -1.5 1H1.5C1.5 1.27614 1.27614 1.5 1 1.5V-1.5Z",
    fill: "inherit",
    mask: "url(#path-1-inside-1_281_2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSingleview);
export default __webpack_public_path__ + "static/media/icon-singleview.3e8df04f.svg";
export { ForwardRef as ReactComponent };